import { colors, fonts } from '@grupoboticario/flora-tokens/dist/eudora/web/ds'

export const eudora = {
  colors,
  fonts,
}
